import React, { useEffect, useMemo } from 'react';
import { IconDropdown } from '../../../common/controls/Controls';
import { routes } from '../../../../utils/helpers/ApiClient';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useRedirectToPage from '../../../../hooks/useRedirectToPage';
import usePermission from '../../../../hooks/usePermission';
import { HomeOutlined, UserOutlined, LoginOutlined } from '@ant-design/icons';
import {
  useLeaveImpersonationMutation,
  useLogoutMutation,
} from '../../../../redux/services/authApi';
import { isNull, isUndefined } from 'lodash';
import { useToastMessages } from '../../../../hooks/useToastMessages';
import PropTypes from 'prop-types';
import { toggleCMSSidebar } from '../../../../redux/slices/localStorageSlice';
import Tooltip from '../../../common/Tooltip/Tooltip';

const Avatar = ({ isExpanded }) => {
  const user = useSelector((state) => state.auth.user);
  const originalUser = useSelector((state) => state.auth.originalUser);

  const superAdmin = usePermission('login-as-user');
  const { t } = useTranslation();
  const redirectToPage = useRedirectToPage();
  const dispatch = useDispatch();
  const [leaveImpersonation, { isSuccess: isImpersonationSuccess }] =
    useLeaveImpersonationMutation();
  const [logout] = useLogoutMutation();
  const { successMessage } = useToastMessages();

  useEffect(() => {
    if (isImpersonationSuccess) {
      successMessage({
        message: 'Pôvodný používateľ prihlásený',
      });
      redirectToPage(routes.cmsDashboard);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isImpersonationSuccess]);

  const profileActions = useMemo(() => {
    const actions = [
      {
        title: t('Prejsť na domovskú stránku'),
        icon: <HomeOutlined />,
        onClick: () => redirectToPage(routes.homePage),
      },
    ];

    if (!isNull(originalUser) && !isUndefined(originalUser)) {
      actions.push({
        title: `${t('Späť k')} ${originalUser.first_name} ${
          originalUser.last_name
        }`,
        icon: <UserOutlined />,
        onClick: () => leaveImpersonation(),
        style: { color: 'rgb(164, 49, 49)' },
      });
    }
    if (superAdmin && (isNull(originalUser) || isUndefined(originalUser))) {
      actions.push({
        title: t('Prihlásiť sa ako iný používateľ'),
        icon: <UserOutlined />,
        onClick: () => redirectToPage(routes.cmsAccountChoose),
      });
    }
    if (isUndefined(originalUser)) {
      actions.push({
        title: t('Odhlásiť'),
        icon: <LoginOutlined />,
        onClick: async () => await logout(),
      });
    }
    return actions;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logout, dispatch, originalUser, redirectToPage, t]);

  return (
    <div className="avatar-user-container">
      <Tooltip
        tooltip={
          !isExpanded && user
            ? `${user.first_name} ${user.last_name}`
            : undefined
        }
        right
      >
        <div
          className="avatar-letter"
          onClick={() => {
            if (isExpanded) {
              redirectToPage(routes.cmsDashboard);
            } else {
              dispatch(toggleCMSSidebar(false));
            }
          }}
        >
          {user
            ? `${(user.first_name?.[0] || '').toUpperCase()}${(user.last_name?.[0] || '').toUpperCase()}`
            : ''}
        </div>
      </Tooltip>
      {isExpanded && (
        <>
          <div
            className="name-container"
            onClick={() => {
              redirectToPage(routes.cmsDashboard);
            }}
          >
            {user ? `${user.first_name} ${user.last_name}` : ''}
          </div>

          <IconDropdown hideTooltip items={profileActions} />
        </>
      )}
    </div>
  );
};

Avatar.propTypes = {
  isExpanded: PropTypes.bool,
};

export default Avatar;
